<template>
  <el-breadcrumb :class="['app-breadcrumb', ifShowMenu ? '' : 'largeMargin']" separator="/" v-if="levelList.length > 1">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        class="alignCenter"
        v-for="(item,index) in levelList"
        :key="item.path">
        <span class="alignCenter" v-if="item.redirect==='noRedirect'|| index==levelList.length-1" >
          <i v-if="item.meta.icon" :class="['iconfont', `icon${item.meta.icon}`]" />
          <span class="no-redirect">{{ item.meta.title }}</span>
        </span>
        <span v-else class="alignCenter">
          <i :class="['iconfont', `icon${item.meta.icon}`]" />
          <a @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
        </span>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { mapState } from 'vuex'
const pathToRegexp = require('path-to-regexp')
export default {
  computed: {
    ...mapState({
      ifShowMenu: state => state.app.ifShowMenu,
    }),
  },
  data() {
    return {
      levelList: []
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]
      // if (!this.isDashboard(first)) {
        // matched = [{ path: '/', meta: { title: '控制面板' }}].concat(matched)
      // }
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'controlPanel'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>
<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  &.largeMargin {
    margin-left: calc( (100% - 1120px) / 2 + 10px);
  }
  span {
    color: #BEBEC8!important;
    .iconfont {
      color: #808293;
      font-size: 24px;
      margin-right: 10px;
    }
    a {
      color: #808293!important;
    }
  }
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
